import Immutable from 'immutable';

const ConcernsSutdentSkillRecord = Immutable.Record({
  groupId: undefined,
  groupCode: undefined,
  recentUnit: undefined,
  studentGeneralInfo: undefined,
  skillScores: undefined,
});

export default class ConcernsSutdentSkill extends ConcernsSutdentSkillRecord { }



// WEBPACK FOOTER //
// ./data/AcademicInfo/ConcernsStudentSkill/model.js